export const isMultipleLevelsColumn = (columnName: string) =>
	columnName.includes(".");
